<template>
    <div class="upload-page">
      <el-upload
        class="upload-demo"
        drag
        action="http://localhost:3000/api/upload_kbfile"
        :http-request="customUpload"
        multiple
        :limit="100"
        :on-exceed="handleExceed"
        :on-change="handleChange"
        :before-upload="beforeUpload"
        :file-list="fileList"
        :on-success="handleSuccess"
        :on-error="handleError"
        accept=".pdf,.txt,.md"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传pdf文件，且不超过100MB</div>
      </el-upload>
    </div>
  </template>
  
  <script>
  import {uploadkbFile,writekbfileConfig} from '../../api/auth';

  export default {
    data() {
      return {
        fileList: [],

      };
    },
    props: {
      uploadedFiles: {
        type: Array,
        required: true
      },
      currentUserId: {
        type: String,
        required: true
      },
    },
    mounted() {

    },
    methods: {
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 100 个文件，本次选择了 ${files.length} 个文件，共选择了 ${fileList.length + files.length} 个文件`);
      },
      handleChange(file, fileList) {
        this.fileList = fileList.slice(-5);
      },
      beforeUpload(file) {
        console.log('上传文件格式:',file.type);
        const isPDF = file.type === 'application/pdf';
        const istxt = file.type === 'text/plain';
        const ismd = file.type === 'text/markdown';
        const isLt100M = file.size / 1024 / 1024 < 100;
        let fileNameWithoutExtension = file.name.replace(/\.txt$/, '');
        fileNameWithoutExtension = fileNameWithoutExtension.replace(/\.pdf$/, '');
        fileNameWithoutExtension = fileNameWithoutExtension.replace(/\.md$/, '');
        const hasDotInName = fileNameWithoutExtension.includes('.');
        const ifExist = this.uploadedFiles.includes(fileNameWithoutExtension);
        if (!isPDF&&!istxt&&!ismd) {
          this.$message.error('上传文件只能是 PDF、txt、markdown 格式!');
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        if (hasDotInName) {
          this.$message.error('上传文件名中不能包含 "." 字符!');
        }
        if (ifExist) {
          this.$message.error('文件已存在，请勿重复上传!');
        }
        return (isPDF||istxt||ismd) && isLt100M && !hasDotInName&& !ifExist;
      },
      handleSuccess(response,file) {
        console.log(response);
        this.$message.success(`${file.name} 上传成功`);
        this.$emit('ifsuccess',true);
        
      },
      handleError( file) {
        this.$message.error(`${file.name} 上传失败`);
        this.$emit('ifsuccess',false);
      },
      async customUpload({file}) {
      const user_id = this.currentUserId;
      const folder_name = this.$route.params.folderName;
      console.log('上传用户：',user_id);
      console.log('上传文件夹：',folder_name);
      try {
        const response = await uploadkbFile(user_id,folder_name,file);
        let config={
          ifUse: true,
          ifVectorDB: -2, //0代表解析中,-1代表解析失败，1代表解析成功
          fileType:file.type,
          uuids: [],
        }
        await writekbfileConfig(user_id,folder_name,response.file_name,config).then((res)=>{
          console.log('写入文件配置',res);
        })
        // this.handleSuccess(response, file, this.fileList);
      } catch (error) {
        this.handleError(error, file, this.fileList);
      }
    }
    }
  };
  </script>
  
  <style scoped>

  .upload-page {
    width: 100%;
    max-width: 600px;
    margin: 50px auto;
    text-align: center;
  }
  
  .upload-demo {
    border: 2px dashed #d9d9d9;
    border-radius: 6px;
    background-color: #fafafa;
    padding: 20px;
  }
  
  .el-upload__text {
    font-size: 16px;
    color: #606266;
  }
  
  .el-upload__tip {
    font-size: 12px;
    color: #909399;
  }
  </style>